import { useState, useCallback } from 'react';

export const useUserPrefill = (formData, setFormData, allUsersList, user_role, setInvitedUserAccess) => {
  const [selectedOrgs, setSelectedOrgs] = useState([]);

  const prefillFormFields = useCallback(
    (email) => {
      if (!email || !allUsersList.length) {
        return;
      }

      const user = allUsersList.find((u) => u.email_id === email);

      if (user) {
        if (setFormData) {
          // Check multiple possible role field names
          const userRole = user.role || user.user_role || user.role_type || user.user_type;
          const isAdmin = userRole === 'admin' || false;
          setFormData((prev) => ({
            ...prev,
            firstName: user.first_name || '',
            lastName: user.last_name || '',
            isAdmin: isAdmin
          }));
        }

        // Don't auto-populate selectedOrgs with user's existing organizations
        // selectedOrgs should only contain newly selected organizations from dropdown
        // This prevents existing organizations from being included in the payload

        // Don't auto-populate advertiserAccess with user's existing advertisers
        // advertiserAccess should only contain advertisers explicitly selected in the UI
      }
    },
    [allUsersList, setFormData, setSelectedOrgs]
  );

  const clearAutoFilledFields = useCallback(() => {
    if (setFormData) {
      console.log('🔍 useUserPrefill: Clearing form fields, setting isAdmin to false');
      setFormData((prev) => ({
        ...prev,
        firstName: '',
        lastName: '',
        org: '',
        advertiserAccess: '',
        isAdmin: false
      }));
    }

    setSelectedOrgs([]);
  }, [setFormData, setSelectedOrgs]);

  const handleOrgSelection = useCallback(
    (org) => {
      const isSelected = selectedOrgs.some((selected) => selected.org_id === org.org_id);

      if (isSelected) {
        const updatedOrgs = selectedOrgs.filter((selected) => selected.org_id !== org.org_id);
        setSelectedOrgs(updatedOrgs);
        setFormData((prev) => ({
          ...prev,
          org: updatedOrgs.map((o) => o.org_name).join(', ')
        }));
      } else {
        const updatedOrgs = [...selectedOrgs, org];
        setSelectedOrgs(updatedOrgs);
        setFormData((prev) => ({
          ...prev,
          org: updatedOrgs.map((o) => o.org_name).join(', ')
        }));
      }
    },
    [selectedOrgs, setFormData]
  );

  return {
    selectedOrgs,
    setSelectedOrgs,
    prefillFormFields,
    clearAutoFilledFields,
    handleOrgSelection
  };
};
